
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"58","height":"58","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32 8.246C18.881 8.246 8.246 18.881 8.246 32c0 13.119 10.635 23.754 23.754 23.754 13.119 0 23.754-10.635 23.754-23.754C55.754 18.881 45.119 8.246 32 8.246zM5.25 32C5.25 17.226 17.226 5.25 32 5.25S58.75 17.226 58.75 32 46.774 58.75 32 58.75 5.25 46.774 5.25 32zm26.71-16.05a5.824 5.824 0 100 11.647 5.824 5.824 0 000-11.647zm-8.819 5.823a8.82 8.82 0 1117.64 0 8.82 8.82 0 01-17.64 0zm4.846 13.999c-1.164-.152-1.905-.167-2.485.033-1.044.36-2.14 1.18-2.977 2.241-.845 1.071-1.293 2.213-1.293 3.127v4.15A17.602 17.602 0 0032 48.98c4.054 0 7.786-1.362 10.769-3.655v-4.151c0-.914-.448-2.056-1.293-3.127-.838-1.061-1.933-1.881-2.977-2.241-.58-.2-1.321-.185-2.485-.033-.213.028-.44.06-.68.094-.964.139-2.125.305-3.334.305-1.208 0-2.369-.166-3.334-.305-.239-.034-.466-.066-.679-.094zm1.207-2.858c.942.134 1.833.26 2.807.26.973 0 1.864-.126 2.806-.26.268-.038.54-.076.818-.113 1.168-.153 2.542-.28 3.85.172 1.69.582 3.234 1.8 4.353 3.217 1.111 1.408 1.937 3.187 1.937 4.983v4.87c0 .445-.198.867-.54 1.151A20.603 20.603 0 0132 51.975c-5.028 0-9.64-1.797-13.224-4.78a1.498 1.498 0 01-.54-1.152v-4.87c0-1.796.826-3.575 1.937-4.983 1.12-1.418 2.663-2.635 4.352-3.217 1.31-.452 2.683-.325 3.85-.172.28.037.551.075.819.113z","fill":"#161F32"}})])
          )
        }
      }
    